import { lazy, Suspense, useEffect } from 'react';
/// Components
import Index from './jsx/index';
import { connect, useDispatch } from 'react-redux';
import { Route, Routes, useLocation, useNavigate, useParams } from 'react-router-dom';
// action
import { checkAutoLogin } from './services/AuthService';
import { isAuthenticated } from './store/selectors/AuthSelectors';
/// Style
import "./other/bootstrap-select/dist/css/bootstrap-select.min.css";
import "./css/style.css";
import Widget from './jsx/pages/Widget';
import Home from './jsx/components/Dashboard/Home';
import MainDashboard from './jsx/pages/MainDashboard/Index';


const SignUp = lazy(() => import('./jsx/pages/Registration'));
const ForgotPassword = lazy(() => import('./jsx/pages/ForgotPassword'));
const Login = lazy(() => {
    return new Promise(resolve => {
        setTimeout(() => resolve(import('./jsx/pages/Login')), 500);
    });
});
const ConfirmationEmail = lazy(() => import('./jsx/pages/Confirmation-email'));

function withRouter(Component) {
    function ComponentWithRouterProp(props) {
        let location = useLocation();
        let navigate = useNavigate();
        let params = useParams();

        return (
            <Component
                {...props}
                router={{ location, navigate, params }}
            />
        );
    }

    return ComponentWithRouterProp;
}

function App(props) {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const REGISTER_URL = process.env.REACT_APP_REGISTER_URL;

    // useEffect(() => {
    //     if (location.pathname === "/page-confirm-email") {
    //         navigate('/page-confirm-email');
    //     } else if (location.pathname === REGISTER_URL) {
    //         navigate(REGISTER_URL);
    //     } else {
    //         checkAutoLogin(dispatch, navigate);
    //     }
    // }, [navigate, dispatch, location.pathname, REGISTER_URL]);

    let routes = (
        <Routes>
            <Route path='/login' element={<Login />} />
            <Route path={REGISTER_URL} element={<SignUp />} />
            <Route path='/page-forgot-password' element={<ForgotPassword />} />
            <Route path="/page-confirm-email" element={<ConfirmationEmail />} />
            <Route path="/inicio" element={<MainDashboard />} />
        </Routes>
    );
    if (true) {
    // if (props.isAuthenticated) {
        return (
            <>
                <Suspense fallback={
                    <div id="preloader">
                        <div className="sk-three-bounce">
                            <div className="sk-child sk-bounce1"></div>
                            <div className="sk-child sk-bounce2"></div>
                            <div className="sk-child sk-bounce3"></div>
                        </div>
                    </div>
                }
                >
                    <Index />
                </Suspense>
            </>
        );

    } else {
        return (
            <div className="vh-100">
                <Suspense fallback={
                    <div id="preloader">
                        <div className="sk-three-bounce">
                            <div className="sk-child sk-bounce1"></div>
                            <div className="sk-child sk-bounce2"></div>
                            <div className="sk-child sk-bounce3"></div>
                        </div>
                    </div>
                }
                >
                    {routes}
                </Suspense>
            </div>
        );
    }
};

const mapStateToProps = (state) => {
    return {
        isAuthenticated: isAuthenticated(state),
    };
};

export default App;
// export default withRouter(connect(mapStateToProps)(App)); 
